import React from 'react';

interface MessageReactionProps {
  reaction: {
    emoji: string;
    from?: string;
    timestamp?: string;
    message_id?: string;
  };
}

const MessageReaction: React.FC<MessageReactionProps> = ({ reaction }) => {
  return (
    <div className="message-reaction">
      <div className="inline-flex items-center justify-center bg-gray-100 rounded-full px-2 py-1 text-sm">
        <span className="text-base mr-1">{reaction.emoji}</span>
      </div>
    </div>
  );
};

export default MessageReaction;
